export default __webpack_public_path__ + "media/flavours/glitch/images/mbstobon-ui-3-910511022c70f4fa81648fac23a90723.png";